import React, { useEffect } from 'react'
import * as moment from 'moment-timezone'
import { getStringsAction } from '../../../store/translation/action'
import { connect } from 'react-redux'
import LoadingSystem from '../../../common/LoadingSystem'
import {
  getLoadingFirstName,
  getLoadingGreeting,
} from '../../../common/LoadingSystem/getLoadingGreeting'

const I18nProvider = (props) => {
  // Get remote translations
  const { getTranslations, selectedLang, loading } = props
  useEffect(() => {
    getTranslations()
  }, [getTranslations])
  moment.locale(selectedLang)
  const loadingGreeting = getLoadingGreeting({
    timezone: moment.tz.guess(true),
    firstName: getLoadingFirstName(),
  })
  return loading ? <LoadingSystem greetingText={loadingGreeting} /> : <>{props.children}</>
}
const mapDispatchToProps = (dispatch) => ({
  getTranslations: () => dispatch(getStringsAction())
})
const mapStateToProps = (state) => ({
  loading: state.translation.translationDictLoading,
  selectedLang: state.translation.selectedLang
})
export default connect(mapStateToProps, mapDispatchToProps)(I18nProvider)
